import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import AdditionalSpecs from './components/AdditionalSpecs'
import MainSpecs from './components/MainSpecs'

const SpecsTable = ({
  specifications: {
    additionalSpecs = [],
    mainSpecs = []
  }
}) =>
  <Fragment>
    { Boolean(mainSpecs.length) && <MainSpecs specs={ mainSpecs } /> }
    { Boolean(additionalSpecs.length) && <AdditionalSpecs specs={ additionalSpecs } /> }
  </Fragment>

export default SpecsTable

SpecsTable.propTypes = {
  specifications: PropTypes.shape({
    additionalSpecs: PropTypes.arrayOf(PropTypes.object),
    mainSpecs: PropTypes.arrayOf(PropTypes.object)
  })
}
